import React from "react";
import { Users } from "lucide-react";
import CustomerListManager from "../../components/smartreach/CustomerListManager";

export default function CustomerLists() {
  return (
    <div style={{ maxWidth: 900 }} data-testid="customer-lists-page">
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
        <Users size={22} style={{ color: "var(--blue)" }} />
        <h1 style={{ fontSize: 22, color: "var(--navy)", margin: 0 }}>Customer Lists</h1>
      </div>
      <p className="sr-muted" style={{ fontSize: 13, marginBottom: 16 }}>
        Upload your own customer list to target them, build a lookalike of your best customers, or suppress existing
        customers from acquisition campaigns. We SHA-256 hash every email & phone before storage and push match-ready
        audiences to Meta and Google.
      </p>
      <div className="sr-card">
        <CustomerListManager />
      </div>
    </div>
  );
}
